/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon-integration': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _stroke="#213F6B" stroke-width="1.5" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M8.363 17.091A2.182 2.182 0 114 17.09a2.182 2.182 0 014.363.002h0zM15.64 6.909a2.182 2.182 0 114.364 0 2.182 2.182 0 01-4.364 0h0z"/><path pid="1" d="M11.275 6.182H9.316A3.15 3.15 0 006.183 9.35v5.559m5.092-8.727L9.093 4m2.182 2.182L9.093 8.363m3.637 9.455h1.957a3.15 3.15 0 003.133-3.168V9.091m-5.091 8.727L14.91 20m-2.181-2.182l2.181-2.181"/></g>'
  }
})
